// import { useEffect } from 'react'
// import { useDispatch } from 'react-redux'
import QrTicketsBlock from '../../components/Qr/QrTickets/QrTicketsBlock'
import ButtonBack from '../../components/reusable/Buttons/ButtonBack'
import BuyQrTyModal from '../../components/reusable/Modals/InfoModals/BuyQrTyModal'
import Subtitle from '../../components/reusable/Titles/Subtitle'
import Title from '../../components/reusable/Titles/Title'
// import { fetchOrders } from '../../redux/thunks/qr'

const QrTickets = () => {
  // const dispatch = useDispatch()
  // useEffect(() => {
  //   dispatch(fetchOrders())
  // }, [dispatch])

  return (
    <div className="qr_tickets_page wrapper_1055">
      <ButtonBack />
      <Title title="Одноразові QR квитки" />
      <Subtitle title="Придбання QR-квитків для проїзду у громадському транспорті" />
      <QrTicketsBlock />
      <BuyQrTyModal />
    </div>
  )
}

export default QrTickets
